<template>
  <div style="overflow: visible">
    <v-navigation-drawer
      v-if="userLogged"
      v-model="drawer"
      :key="mini"
      :mini-variant="mini"
      app
      mobile-breakpoint="960"
      class="glass nav-props icon-menu"
      tile
      height="100%"
      width="240"
      :dark="dark"
      :class="mini ? 'mini-class' : ''"
    >
      <template #prepend>
        <v-toolbar-title class="d-flex justify-space-around align-baseline">
          <v-img
            v-if="!mini"
            :src="require('../../assets/logos/' + logo)"
            :max-width="175"
            contain
            class="mx-auto d-flex justify-end"
          >
          </v-img>

          <v-img
            v-else
            :src="require('../../assets/logos/' + logoMini)"
            :max-width="50"
            contain
            class="mx-auto"
            @click="mini = false"
          />
        </v-toolbar-title>
      </template>

      <v-list class="py-0">
        <v-tooltip right :disabled="!mini">
          <template v-slot:activator="{ on, attrs }">
            <v-list-group
              v-bind="attrs"
              v-on="on"
              :link="!blockAccess"
              :color="color"
              no-action
              :append-icon="null"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon :color="iconColor">mdi-account-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="nombre">
                    {{ userLogged.sucursal }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ userLogged.usuario }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-if="!blockAccess" v-slot:appendIcon>
                <v-icon style="margin-left: 0 !important">mdi-menu-up</v-icon>
              </template>
              <template v-if="!blockAccess">
                <v-list-item
                  v-for="child in ajustesCuenta"
                  :key="child.name"
                  :to="{ name: 'cuenta', params: { ajuste: child.to } }"
                  link
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ child.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon small :color="iconColor">{{ child.icon }}</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
          <span>Cuenta</span>
        </v-tooltip>
      </v-list>
      <v-divider class="mb-1"></v-divider>
      <div class="pa-2">
        <v-btn
          v-if="
            bitsCliente?.b_desarrollo_cliente ||
            bitsCliente?.b_soporte ||
            bitsCliente?.b_cotizacion
          "
          :disabled="userLogged.b_cambia_clave"
          id="ingresaTicket"
          block
          :icon="mini"
          :color="iconColor"
          elevation="0"
          @click="solicitarTicket()"
        >
          <v-icon left>mdi-text-box-plus</v-icon>
          <span v-if="!mini">Solicitar Ticket</span>
        </v-btn>
      </div>
      <v-list v-if="contadorTickets.ticket_qa > 0" nav subheader dense>
        <v-tooltip right :disabled="!mini">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              v-bind="attrs"
              v-on="on"
              :to="{ name: 'qa-cliente' }"
              link
              :color="revisionColor"
              :disabled="userLogged.b_cambia_clave"
            >
              <v-list-item-icon
                id="parent"
                style="margin-right: 25px !important"
              >
                <v-icon color="error"> mdi-alert </v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-bold">
                Revisión Innmediata
              </v-list-item-title>
            </v-list-item>
          </template>
          <span>Requerimientos De Revisión INMEDIATA</span>
        </v-tooltip>
      </v-list>
      <v-list nav subheader>
        <div v-for="item in filteredMenu" :key="item.name">
          <v-subheader style="height: 19px !important" v-if="item.header">
            {{ !mini ? item.header : item.headerShort }}
          </v-subheader>
          <v-tooltip right :disabled="!mini">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                :to="{ name: item.to }"
                :disabled="ticket_qa"
                link
                :color="color"
              >
                <v-list-item-icon
                  id="parent"
                  style="margin-right: 25px !important"
                >
                  <v-badge
                    :value="
                      item.counter_b && contadorTickets[item.counter] === null
                        ? true
                        : contadorTickets[item.counter] > 0
                    "
                    class="badge-off"
                    overlap
                    :offset-x="
                      typeof contadorTickets[item.counter] === 'boolean'
                        ? -1
                        : 6
                    "
                    :dot="typeof contadorTickets[item.counter] === 'boolean'"
                    :color="badgeColor"
                  >
                    <v-icon :color="iconColor" :disabled="ticket_qa" dark>
                      {{ item.icon }}
                    </v-icon>
                    <template #badge>
                      <v-progress-circular
                        v-if="contadorTickets[item.counter] === null"
                        indeterminate
                        size="9"
                        width="1"
                      ></v-progress-circular>
                      <span
                        v-else
                        class="/*!dark ? 'white--text' : 'black--text'*/"
                      >
                        {{ contadorTickets[item.counter] }}
                      </span>
                    </template>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </div>
      </v-list>

      <template v-slot:append>
        <div class="py-1 mb-3" v-if="informativoSideBar && !mini">
          <v-btn
            block
            style="pointer-events: none"
            text
            small
            :color="infoColor"
          >
            <span class="texto-btn">
              {{ informativoSideBar }}
            </span>
          </v-btn>
        </div>
        <div
          v-if="!mini"
          class="px-2 text-center"
          :class="`${scheduleColor}--text`"
          :style="{ color: scheduleColor }"
        >
          <span class="text-button texto-btn">
            Atención de lunes a jueves
            <div>De 8:00 - 14:00 y 15:00 - 18:00</div>
            <div
              class="font-weight-black"
              style="font-size: 0.75rem !important"
            >
              Viernes hasta las 17:00 hrs
            </div>
          </span>
        </div>
        <div class="pa-2">
          <v-btn block :icon="mini" color="error" @click="logout">
            <span v-if="!mini">Cerrar Sesión</span>
            <v-icon v-else>mdi-logout</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <solicitar-ticket
      v-if="dialogSolicitar.state"
      :dialog="dialogSolicitar"
      @cerrar="cerrarSolicitar"
    />
    <v-tooltip
      v-if="tooltip"
      v-model="tooltip"
      color="amber"
      :timeout="15000"
      activator="#ingresaTicket"
      max-width="300"
      bottom
      content-class="click-pointer"
    >
      <div class="d-flex justify-space-around">
        <span class="full-right-tooltip">
          ¡ Ahora puede ingresar sus requerimientos desde un solo lugar !
        </span>
        <v-btn x-small icon class="ml-1" @click="tooltip = false">
          <v-icon color="white">mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import auth from "@/services/auth";
import { menu } from "./data/menu";
import config from "@/config/configBase";
import SolicitarTicket from "../dialogos/SolicitarTicket.vue";

export default {
  components: {
    SolicitarTicket,
  },
  data: () => ({
    ajustesCuenta: [
      { name: "Cambiar Clave", to: "cambiar-clave", icon: "mdi-account-lock" }, //
    ],
    finalItems: [{ name: "Atención Socios", icon: "mdi-phone" }],

    dialog: false,
    userLogged: auth.getUserLogged(),
    dark: config.dark,
    color: config.menuColor,
    iconColor: config.btnColor,
    badgeColor: config.badgeColor,
    infoColor: config.infoTextColor,
    scheduleColor: config.scheduleTextColor,
    logo: config.logoSidebar,
    logoMini: config.logoMini,
    revisionColor: config.revisionColor,
    dialogSolicitar: { state: false, user: {} },
  }),
  computed: {
    ...mapState([
      "mini",
      "contadorTickets",
      "bitsCliente",
      "informativoSideBar",
      "blockAccess",
    ]),
    ...mapGetters(["getParams", "getDrawer", "getTooltip"]),
    ticket_qa() {
      return (
        (this.contadorTickets.ticket_qa > 0 &&
          this.getParams["3134"]?.valor == 1) ||
        this.userLogged.b_cambia_clave
      );
    },
    filteredMenu() {
      return menu.filter(
        (item) =>
          (item.visible_bit ? this.bitsCliente[item.visible_bit] : true) &&
          (item.visible_sucur
            ? item.visible_sucur.includes(this.userLogged.id_sucursal)
            : true)
      );
    },

    drawer: {
      get() {
        return this.getDrawer;
      },
      set(state) {
        this.switchDrawer(state);
        return state;
      },
    },
    tooltip: {
      get() {
        return this.getTooltip;
      },
      set(state) {
        this.SET_TOOLTIP(state);
        return state;
      },
    },
  },
  methods: {
    ...mapActions(["switchDrawer"]),
    ...mapMutations(["SET_TOOLTIP"]),
    logout() {
      auth.cerrarSesion();
    },
    solicitarTicket() {
      this.dialogSolicitar.user = this.userLogged;
      this.dialogSolicitar.state = true;
      this.dialogSolicitar.tipo = 1;
    },
    cerrarSolicitar(solicita) {
      if (solicita) this.$emit("recargar");

      this.dialogSolicitar.state = false;
    },
  },
};
</script>
<style scoped lang="css">
.click-pointer {
  pointer-events: auto !important;
  padding: 5px !important;
  padding-left: 12px !important;
  left: 250px !important;
  font-weight: 500;
  font-size: 19px;
}
.nombre {
  white-space: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
}
.texto-btn {
  width: min-content;
  white-space: normal;
  flex: auto;
  font-weight: 500;
  font-size: 0.7rem !important;
  line-height: 1rem !important;
}
</style>
